import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromCitizenServiceGroup from './citizens-services-groups.reducer';
import { AppState } from 'src/app/store/reducers';


export const currentState = (state: AppState) => (state[fromCitizenServiceGroup.citizensServicesGroupsesFeatureKey]);

export const selectCitizenServiceGroup = createSelector(currentState, fromCitizenServiceGroup.selectAll);

export const selectTotolCitizenServiceCategory = createSelector(currentState, fromCitizenServiceGroup.selectTotal);

export const selectModifiedServiceGroup = createSelector(selectCitizenServiceGroup, (citizens) => {
  return citizens.map((citizen) => {
    return {
      ...citizen
    };
  });
});